export const styles = () => ({
  container: {
    marginTop: 50
  }
})



// WEBPACK FOOTER //
// ./src/components/RoutesTabs/styles.js